package com.hyperether.goodjob.scenes.jobs

import androidx.compose.foundation.layout.Column
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.navigation.NavHostController
import com.hyperether.goodjob.models.Job
import com.hyperether.goodjob.repository.remote.model.CompletionReportResponse
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.error
import com.hyperether.goodjob.scenes.components.ErrorDialog
import com.hyperether.goodjob.util.DocumentType
import com.hyperether.resources.stringResource

@Composable
fun CompletionReportSubmit(
    viewModel: JobDetailsViewModel,
    navHostController: NavHostController,
    job: Job,
    report: CompletionReportResponse?,
    onUploadDocumentClick: (String, DocumentType) -> Unit
) {
    Column(modifier = Modifier) {
        CompletionReportSubmitView(
            job,
            report,
            viewModel,
            submit = {
                viewModel.showLoader.value = true
                job.id?.let {
                    viewModel.submitCompletionReport(it, onSuccess = {
                        viewModel.showLoader.value = false
                        viewModel.showReportSubmitSuccess.value = true
                        viewModel.loadJobDetails(it)
                    }, onError = {
                        viewModel.showLoader.value = false
                        viewModel.showPopUpError.value = true
                    })
                }
            },
            onUploadDocumentClick = onUploadDocumentClick
        )
        if (viewModel.showTaskErrorPopup.value) {
            ErrorDialog(
                onDismiss = { viewModel.showTaskErrorPopup.value = false },
                title = stringResource(Res.string.error).uppercase(),
                message = viewModel.errorText.value
            )
        }
    }
}